import type { AxiosInstance } from 'axios'
import type { IGridSubAccountOperationItem, IWalletData } from '@/typings/wallet'
import type { IGridPayloadRequest } from '@/types/list'
import type { IGridResponse } from '@/typings/api'
import { buildQueryForGrid } from '@/helpers/grid.ts'

export default (axios: AxiosInstance) => ({
    getSubAccountWalletById: async (subAccountId: string): Promise<IWalletData> => {
        const { data } = await axios.get<IWalletData>(`/guardian/${subAccountId}/wallet/details`)

        return data
    },

    getWalletOperationsGrid: async (
        gridPayload: IGridPayloadRequest,
        subAccountId: string,
    ): Promise<IGridResponse<IGridSubAccountOperationItem>> => {
        const query = buildQueryForGrid(gridPayload)

        const { data } = await axios.get<IGridResponse<IGridSubAccountOperationItem>>(
            `/guardian/${subAccountId}/wallet/operations?${query}`,
            {
                signal: gridPayload.signal,
            },
        )

        return data
    },
})
